import { Spinner } from '@frontend/elements';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import SlotOpening from '../../slot-status/slot-opening/slot-opening.component';
import { UserInterfaceProps } from '../../types/user-interface';
import PackageCard from '../package-card/package-card.component';
import usePudoPickList from './pudo-pick-list.controller';

export const PudoPickList = (props: UserInterfaceProps) => {
    const viewProps = usePudoPickList(props);

    if (viewProps.isLoading) {
        return (
            <div className='card'>
                <div className='card-body'>
                    <Spinner />
                </div>
            </div>
        );
    }

    if (viewProps.isPicking && viewProps.pickPackage && viewProps.pickPackage.spot_id) {
        return (
            <SlotOpening
                data={{
                    slot_id: viewProps.pickPackage.slot_id
                }}
            />
        );
    }

    if (viewProps.packages.length === 0) {
        return (
            <div className='d-flex justify-content-center'>
                <h3>
                    <FormattedMessage
                        id='pudo-list.no-pick-up'
                        defaultMessage='No pick-up found'
                    />
                </h3>
            </div>
        );
    }
    return (
        <>
            <div className='d-flex justify-content-center'>
                <h3>
                    <FormattedMessage
                        id='pudo-pick-list.pick-up-list'
                        defaultMessage='Pick-up list'
                    />
                </h3>
            </div>
            <div className='d-flex row'>
                {viewProps.packages
                    .sort((a, b) => a.package.creation_timestamp.localeCompare(b.package.creation_timestamp))
                    .map((pack) => (
                        <PackageCard
                            packageInfo={pack}
                            key={pack.package.id}
                            onPickUp={viewProps.onPickUp}
                        />
                    ))}
            </div>
        </>
    );
};
